import { http } from "./http";
import type { SetlistPending, PreviewResponse, DeliverResponse, ViewResponse, ShopPlaylist } from "../types/setlists";

/** Spotify-matching every row of a long history file takes a while. */
const PREVIEW_TIMEOUT_MS = 180000;

// Sell Playlists: the upload → review → deliver flow, the talent's shelf, and
// the fan's delivered playlist.
export const setlistsApi = {
  pending: () => http.get<SetlistPending>("/setlists/pending"),
  preview: (file: FormData) =>
    http.post<PreviewResponse>("/setlists/preview", file, { headers: { "Content-Type": "multipart/form-data" }, timeout: PREVIEW_TIMEOUT_MS }),
  deliver: (body: { name: string; session: PreviewResponse["session"]; tracks: unknown[] }) =>
    http.post<DeliverResponse>("/setlists/deliver", body),
  shop: () => http.get<{ playlists: ShopPlaylist[] }>("/setlists/shop"),
  createShopPlaylist: (body: { name: string; price: number | null; tracks: unknown[] }) =>
    http.post<{ playlist: ShopPlaylist }>("/setlists/shop", body),
  updateShopPlaylist: (id: string, body: { name: string; price: number | null }) =>
    http.put<{ playlist: ShopPlaylist }>(`/setlists/shop/${id}`, body),
  deleteShopPlaylist: (id: string) => http.delete<unknown>(`/setlists/shop/${id}`),
  view: (receiptId: string) => http.get<ViewResponse>(`/setlists/view/${encodeURIComponent(receiptId)}`),
  musicKitToken: () => http.get<{ token: string }>("/setlists/musickit-token"),
};
